import { gql, useQuery } from "@apollo/client";
import useRetryOn429 from "hooks/useRetryOn429";
import { useEffect } from "react";
import { Select } from "../base/Form";

const FETCH_ODOO_PICKING_TYPES = gql`
  query FETCH_ODOO_PICKING_TYPES {
    odooStockPickingTypes
  }
`;

const OdooPickingTypeSelector = ({
  value,
  onSelect,
  hasAllOption = false,
  initialValue,
  filterFunction,
  ...rest
}) => {
  const { loading, error, data, refetch } = useQuery(FETCH_ODOO_PICKING_TYPES);
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  useEffect(() => {
    if (data && initialValue && value !== initialValue) onSelect(initialValue);
  }, [data]);

  let odooStockPickingTypes = data
    ? JSON.parse(data.odooStockPickingTypes)
    : [];

  if (filterFunction) {
    odooStockPickingTypes = odooStockPickingTypes.filter(filterFunction);
  }

  return (
    <Select
      value={value || "0"}
      onChange={(e) => onSelect(e.target.value)}
      {...rest}
    >
      {loading || isAutoRetrying ? (
        <option value="0" disabled>
          loading...
        </option>
      ) : error ? (
        <option value="0" disabled>
          {error.message}
        </option>
      ) : (
        <>
          <option value="0">{hasAllOption ? "All" : " -- Choose -- "}</option>
          {odooStockPickingTypes.map((i, index) => (
            <option key={index} value={i[0]}>
              {i[1]}
            </option>
          ))}
        </>
      )}
    </Select>
  );
};

export default OdooPickingTypeSelector;
